import noop from "lodash/noop";

import { SWReactIcons } from "@similarweb/icons";
import { Dropdown, EllipsisDropdownItem, IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { TOPICS_WRAPPER_ID } from "../../constants";
import { menuKeys } from "../automationKeys";

import { MENU_WIDTH, MENU_ITEMS, TopicMenu } from "./constants";
import { StyledIcon, StyledInnerItem, StyledMenuWrapper } from "./style";
import type { MenuSchema } from "./type";

export const Menu = ({ onClick, isLoading, isShared, isLastTopic }: MenuSchema) => {
    const onMenuClick = (event: React.SyntheticEvent<HTMLDivElement>) => event.stopPropagation();

    const enabledMenuItems = MENU_ITEMS.filter(({ enabled }) => enabled);

    return (
        <StyledMenuWrapper
            onClick={onMenuClick}
            className="menu-wrapper"
            data-automation={menuKeys.wrapper}
        >
            <Dropdown
                onClick={onClick}
                onToggle={noop}
                dropdownPopupPlacement={isLastTopic ? "top-right" : "bottom-right"}
                autoPlacement
                width={MENU_WIDTH}
                appendTo={`#${TOPICS_WRAPPER_ID}`}
            >
                {[
                    <IconButton
                        key="menuButton"
                        type="flat"
                        iconName="dots-more"
                        isLoading={isLoading}
                    />,
                    ...enabledMenuItems.map(({ id, title, icon }) => (
                        <EllipsisDropdownItem
                            id={id}
                            disabled={id === TopicMenu.Edit ? isShared : null}
                            data-automation={menuKeys.item}
                        >
                            <StyledInnerItem>
                                <StyledIcon>
                                    <SWReactIcons
                                        size="sm"
                                        iconName={icon}
                                    />
                                </StyledIcon>

                                <div>{translate(title)}</div>
                            </StyledInnerItem>
                        </EllipsisDropdownItem>
                    )),
                ]}
            </Dropdown>
        </StyledMenuWrapper>
    );
};
